export default __webpack_public_path__ + "logo1e140b5.png";